import { render, staticRenderFns } from "./SwitchPedBot.vue?vue&type=template&id=07c30c4c"
import script from "./SwitchPedBot.vue?vue&type=script&lang=js"
export * from "./SwitchPedBot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports